import gsap from "gsap";
import { RhLink } from "@components";
import SplitText from "gsap/SplitText";
import { useRef, useEffect } from "react";
import classNames from "classnames/bind"
import { replaceStringVar, sortInductees } from "@/core/utils";
import { GetAdjacentClassesQuery } from "@graphqlTypes";

import styles from './CarouselClasses.module.scss';
import { usePageWrapperData } from "@/providers/PageWrapperContext";
const cx = classNames.bind(styles);

type CarouselClassesCardProps = {
  year: string;
  inductees: GetAdjacentClassesQuery['adjacentInducteeClasses']
};

const InducteeListItem = ({ inductee }: { inductee: CarouselClassesCardProps['inductees'][number] }) => {
  const nameEl = useRef(null);
  gsap.registerPlugin(SplitText);
  useEffect(() => {
    setTimeout(() => {
      SplitText.create(nameEl.current, { type: "lines" });
    }, 150);
  }, [nameEl]);
  return (
    <li key={inductee.title} className={cx("inductee-item")}>
      <p ref={nameEl} className={cx(["name"])}>
        {inductee.title}
      </p>
      <span className={cx("spacer")} />
    </li>
  );
};

export default function CarouselClassesCard({ year, inductees }: CarouselClassesCardProps) {
  const sortedInductees = sortInductees(inductees);
  const { labels } = usePageWrapperData();
  const { andMoreLabel, classOfLabel } = labels || {}; 
  const label = replaceStringVar(classOfLabel, { year: '' });
  return (
    <RhLink
      href={`/inductees/classes/${year}`}
      className={cx("carousel-classes-card")}
    >
      <div className={cx("expanded-content")}>
        <div className={cx("year-header")}>
          <p className={cx(["class", "text-l"])}>{label}</p>
          <p className={cx(["year", "display-xxl"])}>{year}</p>
        </div>
        <ul className={cx("inductees-list")}>
          {sortedInductees.map((inductee, index) => (
            <InducteeListItem
              key={`${inductee.title}-${index}`}
              inductee={inductee}
            />
          ))}
          {inductees.length > 16 && (
            <li className={cx("inductee-item")}>
              <p className={cx(["name"])}>{andMoreLabel}</p>
            </li>
          )}
        </ul>
      </div>
    </RhLink>
  )
}